let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page766_game4/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page766_game4/audio/766_4_group_rules.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game4/img/audioOn.png', iconOff: 'games/page766_game4/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 480,
        x: 960,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game4/audio/766_4_sit_down.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game4/img/audioOn.png', iconOff: 'games/page766_game4/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 373,
        x: 290,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game4/audio/766_4_look.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game4/img/audioOn.png', iconOff: 'games/page766_game4/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 948,
        x: 310,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game4/audio/766_4_listen.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game4/img/audioOn.png', iconOff: 'games/page766_game4/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 948,
        x: 815,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game4/audio/766_4_be_quiet.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game4/img/audioOn.png', iconOff: 'games/page766_game4/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 948,
        x: 1348,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game4/audio/766_4_stand_up.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game4/img/audioOn.png', iconOff: 'games/page766_game4/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 418,
        x: 1321,
      },
      unit: 'px',
    },
  ],
};

export default elements;
